import React, { useRef } from "react";
import { useTranslation } from "react-i18next";
import { Grid } from "@material-ui/core";
import { HeaderHLPure, InputHLPure, DataPickerHLPure, TextAreaHLPure } from "../../pures";
import { ExternalDropZone, Upload } from "@progress/kendo-react-upload";
import { ModalUtil } from "../../pures"
import LabelPure from "../../pures/label/label.pure";

const AddPublicityDataView = (props) => {
  const { t } = useTranslation();
  const { name, setName, startDate, setStartDate, url, setUrl, endDate, setEndDate, description, setDescription, image, setImage, handleImageUpload, imageSrc } = props

  const modalUtil = new ModalUtil()
  const uploadRef = useRef()

  const onInputChange = ({ target }, setValue) => {
    setValue(target.value)
  }

  const modalError = () => {
    modalUtil.showModal('error', 'Ha ocurrido un error, vuelva a intentarlo', 'Operación fallida')
  }

  const modalSuccess = async () => {
    await modalUtil.showModal('success', `Se ha cargado la imagen de la publicidad con éxito`, 'Operación exitosa')
  }

  const onStatusChange = async (event) => {
    if (event.affectedFiles[0].status === 0) modalError()

    if (event.affectedFiles[0].status === 4) modalSuccess()
  }

  return (
    <Grid container spacing={2}>
      <Grid item xs={12}>
        <HeaderHLPure headingNumber={2} style={{ fontSize: '20px' }} title={t("publicityView.addPublicityData")} />
      </Grid>

      <Grid item xs={12} md={6}>
        <Grid container spacing={2}>
          <InputHLPure
            typeInput={"text"}
            labelInput={t("publicityView.addPublicityName")}
            valueInput={name}
            handleChangeInput={(event) => onInputChange(event, setName)}
            inputActive
          />

          <InputHLPure
            typeInput={"url"}
            labelInput={t("publicityView.addPublicityUrl")}
            valueInput={url}
            handleChangeInput={(event) => onInputChange(event, setUrl)}
            inputActive
          />

          <Grid item xs={12}>
            <TextAreaHLPure
              labelTextArea={t("publicityView.addPublicityDescription")}
              valueTextData={description}
              handleChangeTextArea={(event) => onInputChange(event, setDescription)}
            />
          </Grid>
        </Grid>
      </Grid>

      <Grid item xs={12} md={6}>
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <DataPickerHLPure
              labelDataPicker={t("publicityView.addPublicityStartDate")}
              valueDate={startDate}
              handleChangeDate={(event) => onInputChange(event, setStartDate)}
            />
          </Grid>
          <Grid item xs={12}>
            <DataPickerHLPure
              labelDataPicker={t("publicityView.addPublicityEndDate")}
              valueDate={endDate}
              handleChangeDate={(event) => onInputChange(event, setEndDate)}
            />
          </Grid>
          <Grid item xs={12}>
            <LabelPure title={t("publicityView.addPublicityImage")} />
            {
              image ?
                <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', padding: '10px 0' }}>
                  <img src={imageSrc} className="image-forms" />
                </div>
                :
                <ExternalDropZone uploadRef={uploadRef} style={{ border: '3px dashed rgb(0 0 0 / 20%)', backgroundColor: '#00000000', color: 'rgb(0 0 0 / 40%)', fontWeight: '600', fontFamily: '"Quicksand"' }} /* customHint={transl('customHint')} */ />
            }
            <Upload
              onStatusChange={onStatusChange}
              ref={uploadRef}
              batch={false}
              multiple={false}
              defaultFiles={[]}
              withCredentials={false}
              autoUpload={false}
              showActionButtons={false}
              accept=".heic,.png,.jpg,.jpeg,.mov"
              onAdd={(ev) => {
                if (ev.target.files[0]) {
                  const file = ev.target.files[0].getRawFile()
                  handleImageUpload(file)
                  setImage(file)
                }
              }}
              onRemove={() => {
                handleImageUpload(null)
                setImage(null)
              }}
            />
          </Grid>
        </Grid>
      </Grid>
    </Grid>
  );
}

export { AddPublicityDataView as default };